import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

import style from "./ArchiveAction.module.scss";

export interface ArchiveActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}

export const ArchiveAction: React.FC<ArchiveActionProps> = ({ className, disabled = false, ...buttonProps }) => (
  <button {...buttonProps} type="button" className={classNames(style.archiveButton, className)} disabled={disabled}>
    <FormattedMessage id={disabled ? "actions.archived" : "actions.archive"} />
  </button>
);
